/**
 * Where an accepted insert goes: after its anchor paragraph (and the anchor's
 * suggestion portal), but also after paragraphs already inserted at that same
 * anchor. Several inserts after one paragraph (new clauses 16, 17, 18 after
 * 15.5) then keep the order they're applied in, as in the Word redline,
 * instead of each new one landing before the earlier ones.
 */

const anchorIds = new WeakMap<Element, string>();
let nextAnchorId = 0;

function anchorId(anchor: Element): string {
  let id = anchorIds.get(anchor);
  if (!id) {
    id = String(++nextAnchorId);
    anchorIds.set(anchor, id);
  }
  return id;
}

/** The element to insert after for a new paragraph anchored at `anchor` */
export function insertionPointAfter(anchor: Element): Element {
  let point: Element = anchor;
  if (point.nextElementSibling?.classList.contains('suggestion-portal')) {
    point = point.nextElementSibling;
  }
  const id = anchorId(anchor);
  while (point.nextElementSibling instanceof HTMLElement && point.nextElementSibling.dataset.insertedAfter === id) {
    point = point.nextElementSibling;
  }
  return point;
}

/** Mark a paragraph inserted at `anchor`, so later inserts there go after it */
export function markInsertedAfter(paragraph: HTMLElement, anchor: Element) {
  paragraph.dataset.insertedAfter = anchorId(anchor);
}
